import { ChangeDetectionStrategy, Component, inject, input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { SelectItem } from 'primeng/api/selectitem';

@Component({
    selector: 'unified-ui-restricted-label',
    standalone: true,
    imports: [DropdownModule, FormsModule],
    templateUrl: './restricted-label.component.html',
    styleUrl: './restricted-label.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RestrictedLabelComponent {
    // report restricted label options
    readonly options = input<SelectItem[]>([])

    // Selected restricted label option
    selectedValue = model<string>('');
}
